import "../css/SetupCard.css";

const SetupCard = ({ group, index, onClick, description }) => {
  return (
    <div className="cu-setup-card" onClick={() => onClick(index)}>
      <div className="cu-setup-card-icon">
        {group?.name === "Logs" || group?.name === "Inventory" || group?.name === "Credit" ? (
          <span>{group?.icon}</span>
        ) : (
          <img src={group?.icon} width={group?.width} height={group?.height} />
        )}
      </div>
      <div className="cu-setup-card-name">{group?.name}</div>
      <div className="cu-setup-card-desc">{description}.</div>
    </div>
  );
};

export default SetupCard;
